
// ProfileContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, GoogleAuthProvider } from "firebase/auth";
import { jwtDecode } from 'jwt-decode';
const ProfileContext = createContext(null);

const ProfileProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState(null);
  const apiURL = process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_DEV_API_URL : process.env.REACT_APP_PROD_API_URL;

  async function getNewToken() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        fetch(`${apiURL}/api/refreshToken`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            googleID: user.uid,
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            console.log(data.error);
          }
          else {
            localStorage.setItem('token', data.token);
            setUserProfile(data.user);
          }
        })
      }
    });
  }

  function fetchUserProfile() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserProfile(decodedToken.user)
      }
      catch (err) {
        console.log(err);
        getNewToken();
      }
    }
    else {
      getNewToken();
    }
  }
  
  useEffect(() => {
    fetchUserProfile();
  }, []);


  const updateProfile = (profile) => {
    setUserProfile(profile);
  };

  return (
    <ProfileContext.Provider value={{userProfile, updateProfile}}>
      {children}
    </ProfileContext.Provider>
  );
};


export { ProfileProvider, ProfileContext };
